import React from 'react';
import { Link } from 'react-router-dom';

const COLS = [
  {
    title: 'Products',
    links: [
      { label: 'AI Voice Agents', to: '/products/voice-ai' },
      { label: 'Messaging', to: '/products/messaging' },
      { label: 'Web Chat Widget', to: '/products/web-chat' },
      { label: 'Voice Orb', to: '/products/voice-orb' },
      { label: 'Client Onboarding', to: '/products/client-onboarding' },
      { label: 'Leads & Outreach', to: '/products/leads-outreach' },
    ],
  },
  {
    title: 'Industries',
    links: [
      { label: 'Home Services', to: '/solutions/home-services' },
      { label: 'Med Spas & Clinics', to: '/solutions/medical' },
      { label: 'Auto & Dealerships', to: '/solutions/auto' },
      { label: 'Real Estate', to: '/solutions/real-estate' },
      { label: 'Legal', to: '/solutions/legal' },
      { label: 'Restaurants', to: '/solutions/restaurants' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Pricing', to: '/pricing' },
      { label: 'Support', to: '/support' },
      { label: 'Help Center', to: '/help' },
      { label: 'Status', to: '/status' },
      { label: 'Login', to: '/login' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy', to: '/privacy' },
      { label: 'Terms', to: '/terms' },
      { label: 'Trust & Security', to: '/trust' },
    ],
  },
];

const ArcFooter = () => (
  <footer className="arc-bone border-t border-black/[0.06] py-14" data-testid="arc-footer">
    <div className="max-w-[1360px] mx-auto px-6 grid md:grid-cols-[1.5fr_repeat(4,1fr)] gap-10">
      <div>
        <img src="/voxinity-logo-light.png?v=8" alt="Voxinity AI" className="h-8 w-auto" />
        <p className="arc-body text-base text-[#141414]/55 mt-4 max-w-xs leading-relaxed">
          AI employees for agencies — calls answered, chats closed, ads created.
        </p>
      </div>
      {COLS.map((col) => (
        <div key={col.title}>
          <div className="arc-body text-[11px] font-bold uppercase tracking-[0.25em] text-[#141414]/40 mb-4">{col.title}</div>
          <ul className="space-y-2.5">
            {col.links.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.to}
                  className="arc-body text-sm font-medium text-[#141414]/60 hover:text-[#141414] transition-colors"
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="max-w-[1360px] mx-auto px-6 mt-12 pt-6 border-t border-black/[0.06]">
      <p className="arc-body text-xs text-[#141414]/40">© {new Date().getFullYear()} Voxinity AI. All rights reserved.</p>
    </div>
  </footer>
);

export default ArcFooter;
